import { Select, Chip } from '@ui/kit';
import { wrapperCls } from './atom.filters.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

const MegaMenuFilters = ({
  selectedCategories,
  selectedGrades,
  categoryFilters,
  gradeFilters,
  setCategoryFilters,
  setGradeFilters
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: wrapperCls,
    children: [gradeFilters?.length && /*#__PURE__*/jsx(MegaMenuFilterList, {
      items: gradeFilters,
      asSelect: !!categoryFilters?.length,
      toggleItem: toggledGrade => {
        setGradeFilters(selectedGrades.includes(toggledGrade) ? selectedGrades.filter(it => it !== toggledGrade) : [...selectedGrades, toggledGrade]);
      },
      selectedItems: selectedGrades
    }), categoryFilters?.length && /*#__PURE__*/jsx(MegaMenuFilterList, {
      items: categoryFilters,
      toggleItem: toggledFilter => {
        setCategoryFilters(selectedCategories.includes(toggledFilter) ? selectedCategories.filter(it => it !== toggledFilter) : [...selectedCategories, toggledFilter]);
      },
      selectedItems: selectedCategories
    })]
  });
};
const MegaMenuFilterList = ({
  selectedItems,
  items,
  toggleItem,
  asSelect
}) => {
  if (asSelect) {
    return /*#__PURE__*/jsx(Select, {
      label: "V\xE6lg klasser",
      multiSelect: true,
      options: items.map(it => ({
        id: it.value,
        label: it.label
      })),
      selectedValues: selectedItems,
      toggleValue: (value, option) => {
        toggleItem(option.id);
      }
    });
  }
  return /*#__PURE__*/jsx(Fragment, {
    children: items.map(item => {
      const onClick = () => {
        toggleItem(item.value);
      };
      const isActive = selectedItems.includes(item.value);
      return /*#__PURE__*/jsx(Chip, {
        toggled: isActive,
        onClick: onClick,
        disabled: !item.enabled && !isActive,
        children: item.label
      }, item.label);
    })
  });
};

export { MegaMenuFilters };
//# sourceMappingURL=atom.filters.js.map
